<div class="tags-container">
    <div *ngFor="let tag of tags" class="tag">
        {{ tag }}
        <button 
            class="remove-tag" 
            mat-icon-button 
            (click)="removeTag(tag)" 
            type="button"
            [disabled]="disabled">×</button>
    </div>

    <input 
        #inputElement 
        [formControl]="tagInput" 
        [matAutocomplete]="auto" 
        matAutocompleteTrigger
        [matAutocompleteDisabled]="disabled" 
        (keyup.enter)="addTag()" 
        (keydown.enter)="$event.preventDefault();" 
        *ngIf="showInput"
        [disabled]="disabled">

    <button 
        mat-raised-button 
        [ngClass]="showInput ? 'icon-mode' : 'text-mode'" 
        (click)="toggleInput()" 
        type="button"
        [disabled]="disabled">
        {{ showInput ? '×' : 'Add Tag' }}
    </button>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTagSelected($event)">
        <mat-option *ngFor="let suggestion of filteredSuggestions | async" [value]="suggestion">
            {{ suggestion }}
        </mat-option>
    </mat-autocomplete>
</div>
